import React from 'react';
import { useTranslation } from 'react-i18next';
import rem from '../../../utils/rem';
import { Flex, Text } from '../../primitives';

const BIG_ROUND_SIZE = rem(34);

type Props = {
  topTitle: string;
  bottomTitle: string;
  rightValue: number;
  leftValue: number;
  myLabel: string;
  wantedLabel: string;
};

const PersonalityGraph = ({
  topTitle,
  bottomTitle,
  rightValue,
  leftValue,
  myLabel,
  wantedLabel,
}: Props) => {
  const { t } = useTranslation();

  const renderTitle = (text: string) => {
    return (
      <Text
        height={rem(28)}
        color="secondary"
        fontSize={rem(10)}
        lineHeight={rem(14)}
        my={rem(6)}
        textAlign="center"
      >
        {text}
      </Text>
    );
  };

  const renderGraph = (color: string, value: number, label: string) => {
    return (
      <Flex
        height={rem(113)}
        width={rem(6)}
        borderRadius={rem(6)}
        backgroundColor="gallery"
        justifyContent="center"
        mx={rem(12)}
      >
        <Flex
          position="absolute"
          height={BIG_ROUND_SIZE}
          width={BIG_ROUND_SIZE}
          backgroundColor={`${color}Light`}
          borderRadius="50%"
          justifyContent="center"
          alignItems="center"
          p={rem(5)}
          bottom={`calc((100% - ${BIG_ROUND_SIZE})*${value})`}
        >
          <Flex
            backgroundColor={`${color}`}
            borderRadius="50%"
            justifyContent="center"
            alignItems="center"
          >
            <Text fontSize={rem(10)} color="light">
              {t(label)}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width={rem(120)}
      flexGrow={0}
    >
      {renderTitle(topTitle)}
      <Flex>
        {renderGraph('apricot', rightValue, myLabel)}
        {renderGraph('accent', leftValue, wantedLabel)}
      </Flex>
      {renderTitle(bottomTitle)}
    </Flex>
  );
};

export default PersonalityGraph;
